
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/doc/kyc",
      function () {
        return require("private-next-pages/doc/kyc.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/doc/kyc"])
      });
    }
  